module.exports = __webpack_public_path__ + "img/landing-banner-1200.7db77cfd.png";